import React, { useEffect, useState } from "react";
import "../style/auth.scss";
import * as formik from "formik";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useAuth } from "../contexts/AuthContext";
import { TOKEN_KEY } from "../constants/key.const";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const SignIn = () => {
  const { Formik } = formik;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const { loginUser } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const schema = yup.object().shape({
    email: yup.string().required("Email is required"),
    password: yup.string().required("Password is required"),
    code: yup.string(),
  });

  useEffect(() => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (token) {
      navigate("/home/walkthrough/record");
    }
  }, [navigate]);
  const handleSubmitData = async (data, { resetForm }) => {
    const { email, password, code } = data;
    const result = await loginUser(email, password, code);
    if (result.success) {
      resetForm();
      navigate("/home/walkthrough/record");
    } else {
      setErrorMessage(result.message || "Invalid email or password");
    }
  };
  return (
    <section className="main-auth">
      <div className="main-auth-form">
        <div className="w-full flex justify-start">
          <img
            onClick={() => navigate("/")}
            src="/Logo1.png"
            className="sm:max-w-[330px] max-w-[130px] max-h-[70px] h-auto object-contain cursor-pointer w-36"
            alt="logo"
          />
        </div>
        <h3 className="text-3xl font-bold">Login</h3>
        {/* <p className="mb-0">
          Don't have an account?
          <NavLink to="/sign-up">&nbsp; Sign Up</NavLink>
        </p> */}
        <Formik
          validationSchema={schema}
          onSubmit={handleSubmitData}
          initialValues={{
            email: "",
            password: "",
            code: "",
          }}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit} className="mt-4 py-1">
              <Form.Group controlId="email">
                <Form.Control
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="password" className="mt-4">
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />

                  <FontAwesomeIcon
                    onClick={() => setShowPassword(!showPassword)}
                    icon={showPassword ? faEyeSlash : faEye}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {errorMessage && (
                <div className="text-danger text-center mt-3">
                  {errorMessage}
                </div>
              )}
              {/* <div className="mt-3">
                <NavLink to="/forgot-password">Forgot Password?</NavLink>
              </div> */}

              <Button
                type="submit"
                variant="primary"
                className="w-100 mt-4 auth-button !bg-custom-green text-white"
              >
                Sign In
              </Button>
              {/* <div className="or">Or</div>

              <MicrosoftAuthComponent /> */}

              <hr />

              <div className="message">
                Protected by reCAPTCHA and subjected to Rhombus{" "}
                <NavLink className="text-custom-green">Privacy Policy </NavLink>{" "}
                and{" "}
                <NavLink className="text-custom-green">
                  Terms of Service.
                </NavLink>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default SignIn;
